import React from 'react';
import * as R from 'ramda';
import classNames from 'classnames';

import Button from './Button';
import { ImageService } from '../../../main/services/ImageService/ImageService';

type Props = {
  containerClassName?: string;
  children: React.ReactNode;
  testid?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

class AddFieldButton extends React.Component<Props> {
  render() {
    const defaultProps = {
      testid: 'add-field',
    };
    const props = {
      ...defaultProps,
      ...this.props,
    };

    const buttonProps = R.omit(['containerClassName'], props);

    return (
      <div className={classNames('add-field', props.containerClassName)}>
        <Button size="no-miw" type="dashed" {...buttonProps}>
          {props.children}
          <img className="add-field-icon" src={ImageService.getImageUrl('/static/images/editor/ic_add_button.svg')} />
        </Button>
      </div>
    );
  }
}

export default AddFieldButton;
